import { apiHelper } from './api_helper';

export const CAUHINH_MAHOCSINH_API_END_POINT = "cauhinh-mahocsinh";
export const cauHinhMaHocSinhApi = {
  SelectByCoSo: (dm_coso_id) => apiHelper.get(`co-so/${dm_coso_id}/cauhinh-mahocsinh`),
  SelectById: (id) => apiHelper.get(`${CAUHINH_MAHOCSINH_API_END_POINT}/${id}`),
  Insert: (data) => apiHelper.post(`${CAUHINH_MAHOCSINH_API_END_POINT}`, data),
  Update: (data) => apiHelper.put(`${CAUHINH_MAHOCSINH_API_END_POINT}`, data),
  Delete: (id) => apiHelper.delete(`${CAUHINH_MAHOCSINH_API_END_POINT}/${id}`),
}
